<template>
    <div id="addTypes">
        <el-card shadow="never">
            <el-row>
                <el-col :span="10" :offset="1">
                    <el-form
                        :model="ruleForm"
                        :rules="rules"
                        ref="ruleForm"
                        status-icon
                        label-width="120px"
                        v-loading="loading"
                        element-loading-text="努力加载中"
                        element-loading-spinner="el-icon-loading"
                    >
                        <el-form-item label="订单超时时间/s" prop="orderOutTime">
                            <el-input
                                v-model="ruleForm.orderOutTime"
                                placeholder="请输入订单超时时间"
                                :disabled="disabled"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="订单请求时间/s" prop="orderPayListenTime">
                            <el-input
                                v-model="ruleForm.orderPayListenTime"
                                placeholder="请输入订单请求时间"
                            ></el-input>
                        </el-form-item>
                        <el-form-item class="submit">
                            <el-button
                                type="primary"
                                @click="submitForm('ruleForm')"
                                >保存</el-button
                            >
                            <el-button @click="cancel()">返回</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>

<script>
import axios from '../../env/axios'
import apis from '../../env/apis'
import requestMixin from '../../mixins/request'
import common from '../../mixins/common'
export default {
    mixins: [requestMixin, common],
    inject: ['reload'],
    data () {
        return {
            disabled: false,
            ruleForm: {
                orderOutTime: '',
                orderPayListenTime: ''
            },
            rules: {
                orderOutTime: [
                    { required: true, message: '请输入订单超时时间', trigger: "blur" },
                    { min: 1, max: 100, message: '长度在3到100个字符', trigger: 'blur' }
                ],
                orderPayListenTime: [
                    { required: true, message: '请输入订单请求时间', trigger: 'blur' },
                    { min: 1, max: 100, message: '长度在3到100个字符', trigger: 'blur' }
                ]
            },
            res: null,
            loading:false
        }
    },
    mounted(){
        this.$nextTick(() => {
            this.refreshTypes();
        })
    },
    methods:{
        submitForm(formName){
            this.$refs[formName].validate((valid) => {
                // console.log(formName)
                let that = this;
                let userId = sessionStorage.getItem('userId');
                if(valid){
                    // console.log(that.ruleForm)
                    let {orderOutTime,orderPayListenTime} = that.ruleForm;
                    let params = {
                        act:'setSysSetting',
                        userId,
                        orderOutTime,
                        orderPayListenTime
                    }
                    that.loading = true;
                    that.delType(params).then((res) => {
                        // console.log(res)
                        let {code,status} = res.data;
                        if(status){
                            that.loading=false;
                            that.$message({
                                type: 'success',
                                message: '更新时间成功 √ '
                            });
                            that.$router.push({ path:'/system/orderTime'})
                        }else{
                            that.loading=false;
                            this.alert('更新时间失败', 'warning')
                        }
                    }).catch(error => {
                        that.loading=false;
                    })
                }

            })
        },
        refreshTypes () {
            // console.log('刷新')
            let that = this;
            let userId = sessionStorage.getItem('userId');
            // console.log(userId)
            let params = {
                act:'getSysSetting',
                userId
            }
            that.loading = true;
            that.delType(params).then((res) => {
                let { code,data } = res.data;
                if(code == 200){
                    that.loading=false;
                    that.ruleForm = data ;
                }
            }).catch((error) => {
                that.loading=false;
                that.$alert('请求不到数据或网络连接异常', '提示', {
                    confirmButtonText: '确定',
                    type: 'error',
                    center: true
                })
            })
        },
        cancel(){
           this.$router.go(-1)
        },
    }
}
</script>

<style scoped>
</style>